import { render, staticRenderFns } from "./ErrorNotification.vue?vue&type=template&id=fca36f9e&scoped=true&lang=pug&"
import script from "./ErrorNotification.vue?vue&type=script&lang=ts&"
export * from "./ErrorNotification.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorNotification.vue?vue&type=style&index=0&id=fca36f9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca36f9e",
  null
  
)

export default component.exports